import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { getItems } from '../../../actions/itemActions';
import { Card, Button } from 'react-bootstrap';

// Custom Arrow Component
const Arrow = ({ className, style, onClick, direction }) => (
  <div
    className={className}
    style={{
      ...style,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '38px',
      height: '38px',
      borderRadius: '50%',
      background: '#2323c7',
      color: '#fff',
      fontSize: '20px',
      fontWeight: 'bold',
      zIndex: 3,
      cursor: 'pointer',
      top: '40%',
      boxShadow: '0 4px 10px rgba(0,0,0,0.2)',
      transition: 'all 0.3s ease',
      [direction === 'left' ? 'left' : 'right']: '-50px', // push arrows outside
    }}
    onClick={onClick}
    onMouseOver={(e) => (e.currentTarget.style.background = '#15157a')}
    onMouseOut={(e) => (e.currentTarget.style.background = '#2323c7')}
  >
    {direction === 'left' ? '‹' : '›'}
  </div>
);

const ProductHomeSlider = () => {
  const dispatch = useDispatch();
  const { items } = useSelector((state) => state.itemReducer);

  useEffect(() => {
    dispatch(getItems('api/product/'));
  }, [dispatch]);

  const settings = {
    dots: true,
    infinite: true,
    speed: 600,
    slidesToShow: 5,
    slidesToScroll: 5,
    nextArrow: <Arrow direction="right" />,
    prevArrow: <Arrow direction="left" />,
    appendDots: dots => (
      <div
        style={{
          bottom: '-35px',
        }}
      >
        <ul style={{ margin: '0px' }}> {dots} </ul>
      </div>
    ),
    customPaging: () => (
      <div
        style={{
          width: '10px',
          height: '10px',
          borderRadius: '50%',
          background: '#bbb',
          transition: 'background 0.3s ease',
        }}
      />
    ),
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <div className="p-0" style={{ position: 'relative' }}>
      <div>
        <h2
          style={{
            color: 'white',
            backgroundColor: 'rgb(35, 35, 199)',
            padding: '10px',
            textAlign: 'center',
            borderRadius: '4px',
            marginBottom: '20px',
          }}
        >
          Featured Products
        </h2>
        <Slider {...settings}>
          {items.map((item) => (
            <div key={item.id} className="px-2">
              <Link
                to="/detail_product"
                style={{ textDecoration: 'none' }}
                state={{ item: item }}
              >
                <Card
                  style={{
                    width: '100%',
                    minHeight: '360px',
                    boxShadow: '0 4px 8px rgba(0,0,0,0.15)',
                    borderRadius: '8px',
                    transition: 'all 0.3s ease',
                  }}
                  onMouseOver={(e) => {
                    e.currentTarget.style.boxShadow =
                      '0 8px 20px rgba(0,0,0,0.25)';
                    e.currentTarget.style.transform = 'translateY(-5px)';
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.boxShadow =
                      '0 4px 8px rgba(0,0,0,0.15)';
                    e.currentTarget.style.transform = 'translateY(0)';
                  }}
                >
                  <Card.Img
                    variant="top"
                    src={item.thumbnail}
                    style={{
                      height: '180px',
                      objectFit: 'cover',
                      borderTopLeftRadius: '8px',
                      borderTopRightRadius: '8px',
                    }}
                  />
                  <Card.Body style={{ textAlign: 'center' }}>
                    <Card.Title
                      style={{
                        height: '40px',
                        fontSize: '16px',
                        fontWeight: '600',
                      }}
                      className="overflow-hidden"
                    >
                      {item.title?.length > 25
                        ? item.title?.substring(0, 25) + '...'
                        : item.title}
                    </Card.Title>
                    <Card.Text
                      style={{
                        height: '60px',
                        fontSize: '14px',
                        color: '#555',
                        overflow: 'hidden',
                      }}
                      dangerouslySetInnerHTML={{
                        __html:
                          item.description?.length > 80
                            ? item.description?.substring(0, 80) + '...'
                            : item.description,
                      }}
                    />
                    <Card.Text
                      style={{
                        fontSize: '16px',
                        fontWeight: 'bold',
                        marginBottom: '12px',
                      }}
                    >
                      ₦{item.gen_price}
                    </Card.Text>
                    <Button
                      variant="primary"
                      style={{
                        padding: '6px 16px',
                        borderRadius: '6px',
                        fontSize: '14px',
                      }}
                    >
                      Shop Now
                    </Button>
                  </Card.Body>
                </Card>
              </Link>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default ProductHomeSlider;
